module.exports = __webpack_public_path__ + "img/Mask Group@2x.3f122ce5.png";